export default __webpack_public_path__ + "static/media/page_not_found.2a07f8e7.png";